import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import api, { formatMoney } from "../../lib/api";

export const avisarRevision = () => window.dispatchEvent(new Event("libre-revision"));

export function AvisoCaros({ version = 0, enlace = true }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const cargar = () => api.get("/libre-excluidos/aviso").then((r) => setD(r.data)).catch(() => setD(null));
    cargar();
    window.addEventListener("libre-revision", cargar);
    return () => window.removeEventListener("libre-revision", cargar);
  }, [version]);
  if (!d?.nuevos) return null;
  return (
    <div className="mb-5 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 flex items-center gap-3 flex-wrap fade-in" data-testid="aviso-caros">
      <AlertTriangle size={18} className="text-amber-600 shrink-0" />
      <div className="flex-1 min-w-[240px] text-sm text-amber-900">
        <b>{d.nuevos} medicamento{d.nuevos > 1 ? "s" : ""} caro{d.nuevos > 1 ? "s" : ""} nuevo{d.nuevos > 1 ? "s" : ""}</b> en {d.label} ({formatMoney(d.importe)}) cuentan como venta libre.
        Revísalos antes de calcular los incentivos: quítalos si no llevan trabajo de venta o márcalos como revisados.
      </div>
      {enlace && <Link to="/empleados?tab=grupal" className="btn btn-sm btn-primary" data-testid="aviso-caros-revisar">Revisar <ArrowRight size={13} /></Link>}
    </div>
  );
}
